import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { CtaBand } from '../components/CtaBand';
import { Ledger } from '../components/Ledger';
import { PUBLISHED, findPost } from '../data/posts';
export function Post() {
  const {
    slug = ''
  } = useParams();
  const post = findPost(slug);
  if (!post) {
    return <>
        <header className="hero" data-id="element-670" data-mp="bev5dkxzmc49">
          <div style={{
          width: '100%'
        }} data-id="element-671" data-mp="bfog0x02hlro">
            <div className="lab-row" data-id="element-672" data-mp="1900wkjpsz5vq">
              <span className="clabel" data-id="element-673" data-mp="19358k39if5wy">Signals</span>
            </div>
            <div className="head-block" data-id="element-674" data-mp="143aiu31h0mdh">
              <h1 style={{
              maxWidth: '24ch'
            }} data-id="element-675" data-mp="144bv2au83ews">That one isn&rsquo;t here.</h1>
            </div>
            <div className="sub-block" data-id="element-676" data-mp="z8wirnbv5r2h">
              <p className="sub" style={{
              maxWidth: '58ch'
            }} data-id="element-677" data-mp="ucy0mhh4p5ai">
                The piece you followed has moved or never existed. The index has everything we&rsquo;ve published.
              </p>
              <p style={{
              marginTop: 24
            }} data-id="element-678" data-mp="1n0lgjj7gf7qt">
                <Link className="slink" to="/blog" data-id="element-679" data-mp="1mzirlgtozfdj">
                  All signals &rarr;
                </Link>
              </p>
            </div>
          </div>
        </header>
        <CtaBand data-id="element-680" data-mp="2hwug5ru424rw" />
        <Ledger data-id="element-681" data-mp="2hxci953gfd7q" />
      </>;
  }

  // Order is newest-first, so "previous" is the newer neighbour.
  const i = PUBLISHED.findIndex(p => p.slug === post.slug);
  const newer = i > 0 ? PUBLISHED[i - 1] : undefined;
  const older = i >= 0 && i < PUBLISHED.length - 1 ? PUBLISHED[i + 1] : undefined;
  return <>
      <header className="hero" data-id="element-682" data-mp="1uaxpy5vkvpwa">
        {/* Full-width hero: no .col-l, whose divider would double the frame's
            own right rule. */}
        <div style={{
        width: '100%'
      }} data-id="element-683" data-mp="1kb6qrqw2ompv">
          <div className="lab-row phead" data-id="element-684" data-mp="1kchx9ygwk8ko">
            <span className="clabel" data-id="element-685" data-mp="1p8ym6uvxeqyt">{post.category}</span>
            <Link className="slink" to="/blog" data-id="element-686" data-mp="1pbksysazt2fz">
              &larr; All signals
            </Link>
          </div>
          <div className="head-block" data-id="element-687" data-mp="3jnhniu4qeof9">
            <h1 style={{
            maxWidth: 'none',
            fontSize: 'clamp(30px,4vw,50px)'
          }} data-id="element-688" data-mp="3jmgbambzbvvy">{post.title}</h1>
          </div>
          <div className="sub-block" style={{
          paddingBottom: 34
        }} data-id="element-689" data-mp="3i73vi1kidhb9">
            <div className="bmeta" data-id="element-690" data-mp="3d6pxzdgj9prh">
              <time dateTime={post.date} data-id="element-691" data-mp="3d5o8w52on2qr">{post.dateLabel}</time>
              <span data-id="element-692" data-mp="387mqzngzt9gv">{post.author}</span>
            </div>
          </div>
        </div>
      </header>

      {post.hero ? <div className="pix pimg" data-id="element-693" data-mp="33ad4ogowhdx9">
          <img src={post.hero} alt="" data-id="element-694" data-mp="33b65l116h97h" />
        </div> : null}

      <article className="partl" data-id="element-695" data-mp="4q4lhmop0ejm">
        {post.body.map((block, n) => {
        if (block.t === 'h2') return <h2 key={n} data-id="element-696" data-mp="3vy8zffuwsvre">{block.x}</h2>;
        if (block.t === 'ul') return <ul key={n} data-id="element-697" data-mp="3r5pj4b4u7miw">
                {block.items.map((item, m) => <li key={m} data-id="element-698" data-mp="3m8pd207zmjrs" data-mpi={m}>{item}</li>)}
              </ul>;
        if (block.t === 'link') return <p key={n} data-id="element-699" data-mp="nk0bwm78uv63">
                <a className="plink" href={block.href} target="_blank" rel="noopener noreferrer" data-id="element-700" data-mp="irgzhskam62v">
                  {block.label} &rarr;
                </a>
              </p>;
        return <p key={n} data-id="element-701" data-mp="v1gen05509n5" data-mpi={n}>{block.x}</p>;
      })}
      </article>

      <nav className="pnav" aria-label="More signals" data-id="element-702" data-mp="v1yhwgq7vo4k">
        <div className="pnavc" data-id="element-703" data-mp="10001d2rk1pgk">
          {newer ? <Link to={`/blog/${newer.slug}`} data-id="element-704" data-mp="zz84zpq4vnp8">
              <span className="l" data-id="element-705" data-mp="1505me03bkdpo">&larr; Newer</span>
              <span className="t" data-id="element-706" data-mp="150xf935j7xc9">{newer.title}</span>
            </Link> : null}
        </div>
        <div className="pnavc" data-id="element-707" data-mp="19wmm7rjvsgil">
          {older ? <Link to={`/blog/${older.slug}`} data-id="element-708" data-mp="1dz9532ykqr3n">
              <span className="l" data-id="element-709" data-mp="1dy7wd5516gp3">Older &rarr;</span>
              <span className="t" data-id="element-710" data-mp="1is291om7xveo">{older.title}</span>
            </Link> : null}
        </div>
      </nav>

      <CtaBand data-id="element-711" data-mp="1nosrujper53s" />
      <Ledger data-id="element-712" data-mp="1npc5ho80z7c0" />
    </>;
}